import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { normalizeThresholdColorHex } from 'src/app/shared/utils/threshold-color.util';
import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { Parameter, ParameterThreshold, ThresholdLegendItem } from 'src/app/models/parameter.model';
import { WorkerExposure } from 'src/app/models/exposureBySeg.model';

@Component({
  standalone: false,
  selector: 'app-worker-exposures',
  templateUrl: './worker-exposures.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./worker-exposures.component.scss']
})
export class WorkerExposuresComponent implements OnChanges {
  @Input() parameter: Parameter;
  @Input() workerExposures: WorkerExposure[];

  showInfo: boolean = false;
  thresholdLegend: ThresholdLegendItem[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.parameter) {
      this.thresholdLegend = this.buildThresholdLegend(this.parameter?.thresholds);
    }
  }

  toggleInfo(show: boolean) {
    this.showInfo = show;
  }

  public trackByIndex = trackByIndex;

  private buildThresholdLegend(thresholds: ParameterThreshold[] | undefined): ThresholdLegendItem[] {
    if (!thresholds?.length) {
      return [];
    }

    return [...thresholds]
      .sort((left, right) => left.sortOrder - right.sortOrder)
      .map((threshold) => ({
        colorHex: normalizeThresholdColorHex(threshold.colorHex) ?? '#000000',
        label: threshold.maxValue == null
          ? `≥ ${threshold.minValue}`
          : `${threshold.minValue} - ${threshold.maxValue}`,
      }));
  }
}
